// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pause"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 17L11 7H8V17H11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 17L16 7H13L13 17H16Z"}}]}]};

const PauseIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pause',
    ref,
    icon: element,
  },
));

PauseIcon.displayName = 'PauseIcon';

export default PauseIcon;
